module.exports = __webpack_public_path__ + "static/content_sla-234326140c30b929805e1a53975e0ef4.svg";